<template>
  <!--
    ทั้งใบกดได้เหมือนการ์ดอื่นในหน้านี้ (ProductCategories / ExpenseCategories / KdsStations)
    ต่างกันแค่การ์ดพวกนั้นเป็น router-link ส่วนอันนี้เปิด offcanvas
    role="button" ให้ cursor: pointer จาก bootstrap reboot + semantic ที่ถูกต้อง
  -->
  <div
    class="card mx-3 mt-3 mb-3"
    role="button"
    @click="$emit('edit')"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-receipt me-2 text-primary" />
          {{ $t('VAT Registration') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ isVatRegistered ? summary : $t('This shop is not VAT-registered — receipts are not tax invoices.') }}
        </div>
        <!--
          migration ที่ย้ายค่าภาษีขึ้นมาระดับร้านไม่มีชื่อผู้ประกอบการให้ยกมา (เป็นฟิลด์ใหม่)
          ร้านที่จด VAT จึงต้องมากรอกเอง ไม่งั้นใบกำกับที่พิมพ์ออกไปไม่ครบตามกฎหมาย

          ร้านไม่จด VAT ก็เตือนเหมือนกัน เพราะใบเสร็จรับเงิน/บิลเงินสด บังคับมี
          ชื่อผู้ประกอบการ + เลขประจำตัวผู้เสียภาษี เช่นกัน (เลขบัตรประชาชนก็ได้)
        -->
        <div v-if="isVatRegistered && !tax.tax_entity_name" class="text-danger mt-1" style="font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation me-1" />
          {{ $t('Registered business name is missing — tax invoices need it.') }}
        </div>
        <div v-else-if="!isVatRegistered && (!tax.tax_entity_name || !tax.tax_id)" class="text-warning-emphasis mt-1" style="font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation me-1" />
          {{ $t('Business name and tax ID are missing — receipts need them.') }}
        </div>
      </div>
      <i class="fa-solid fa-chevron-right text-muted" />
    </div>
  </div>
</template>

<script lang="js">
/**
 * สรุปสถานะการจด VAT ของร้าน — แก้ไขผ่าน OffcanvasTaxForm (การ์ดไม่ยิง API เอง)
 * ค่าพวกนี้เป็นของนิติบุคคล ไม่ใช่ของสาขา (silver-spoon-api/docs/vat-compliance.md §2)
 */
export default {
  name: 'TaxSettingsCard',
  emits: ['edit'],
  props: {
    // มาจาก GET ครั้งเดียวที่หน้า settings
    tax: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVatRegistered() {
      return !!this.tax.tax_policy && this.tax.tax_policy !== 'no_tax';
    },
    summary() {
      const policy = this.tax.tax_policy === 'excluded'
        ? this.$t('VAT Excluded')
        : this.$t('VAT Included');
      const parts = [
        policy + ' ' + (this.tax.vat_rate || 0) + '%',
        this.$t('Tax ID') + ' ' + (this.tax.tax_id || '-'),
      ];
      if (this.tax.tax_entity_name) parts.push(this.tax.tax_entity_name);
      return parts.join(' · ');
    }
  }
};
</script>
